// extracted by mini-css-extract-plugin
export default {"tableWrapper":"Projects_tableWrapper__7mFru","tableIcon":"Projects_tableIcon__65Mdo"};